function initNavBurger() {
  const nav = document.querySelector("#main-nav");
  if (!nav) return;

  const list = nav.querySelector(".main-nav-list");
  const burgerTemplate = document.querySelector("#burger-template");
  if (!list || !burgerTemplate?.content) return;

  const burgerClone = burgerTemplate.content.cloneNode(true);
  const button = burgerClone.querySelector(".toggle-nav");
  if (!button) return;

  button.addEventListener("click", () => {
    const isOpen = button.getAttribute("aria-expanded") === "true";
    button.setAttribute("aria-expanded", String(!isOpen));
  });

  nav.addEventListener("keyup", (event) => {
    if (event.code === "Escape") {
      button.setAttribute("aria-expanded", "false");
    }
  });

  nav.insertBefore(burgerClone, list);
}

function initMusicAlbumHover() {
  const albums = document.querySelectorAll(".music-album-cover");
  if (!albums.length) return;

  albums.forEach((album) => {
    const linkWrapper = album.closest("a");
    const targetElement = linkWrapper || album;
    let enterTimeout;
    let leaveTimeout;

    targetElement.addEventListener("mouseenter", () => {
      const vinyl = album.querySelector(".vinyl");

      if (vinyl) {
        if (leaveTimeout) {
          clearTimeout(leaveTimeout);
          leaveTimeout = null;
        }

        enterTimeout = setTimeout(() => {
          vinyl.offsetHeight;
          vinyl.classList.add("spin");
        }, 1000);
      }
    });

    targetElement.addEventListener("mouseleave", () => {
      const vinyl = album.querySelector(".vinyl");
      if (vinyl) {
        if (enterTimeout) {
          clearTimeout(enterTimeout);
          enterTimeout = null;
        }

        leaveTimeout = setTimeout(() => {
          vinyl.classList.remove("spin");
        }, 1000);
      }
    });
  });
}

function initMoviePosterHover() {
  const moviePosters = document.querySelectorAll(".movie-poster-wrapper");
  if (!moviePosters.length) return;

  moviePosters.forEach((moviePoster) => {
    let stopTimeout;
    const img = moviePoster.querySelector("img");
    if (!img) return;

    moviePoster.addEventListener("mouseenter", () => {
      if (stopTimeout) {
        clearTimeout(stopTimeout);
        stopTimeout = null;
      }

      img.style.removeProperty("animation");
      moviePoster.classList.add("movie-poster-animating");
    });

    moviePoster.addEventListener("mouseleave", () => {
      const computedStyle = window.getComputedStyle(img);
      img.style.animation = computedStyle.animation;
      img.style.opacity = "1";
      img.style.transition = "opacity 1s ease-in-out";

      moviePoster.classList.remove("movie-poster-animating");

      requestAnimationFrame(() => {
        img.style.opacity = "0.8";
      });

      stopTimeout = setTimeout(() => {
        img.style.removeProperty("animation");
        img.style.removeProperty("opacity");
        img.style.removeProperty("transition");
      }, 800);
    });
  });
}

function initActiveNavLinks() {
  const currentPath = window.location.pathname;
  const navLinks = document.querySelectorAll("nav a[href].main-nav-link");

  navLinks.forEach((link) => {
    const linkPath = new URL(link.href).pathname;

    link.removeAttribute("aria-current");

    if (currentPath.startsWith(linkPath) && linkPath !== "/") {
      link.setAttribute("aria-current", "page");
    } else if (linkPath === "/" && currentPath === "/") {
      link.setAttribute("aria-current", "page");
    }
  });
}

const storageKey = "theme-preference";
const themeColors = {
  dark: "#14161e",
  light: "#FFFFFF",
};

const theme = {
  value: getColorPreference(),
};

function updateCommentsWrapperColor() {
  const commentsWrapper = document.querySelector(".comments-wrapper");
  if (commentsWrapper) {
    commentsWrapper.style.color =
      theme.value === "dark" ? "#FFFFFF" : "#14161e";

    updateIframeTheme(commentsWrapper);
  }
}

function updateIframeTheme(commentsWrapper) {
  const iframe = commentsWrapper.querySelector("iframe");
  if (iframe) {
    try {
      if (
        iframe.contentDocument &&
        iframe.contentDocument.readyState === "complete"
      ) {
        applyThemeToIframe(iframe);
      } else {
        iframe.addEventListener("load", () => applyThemeToIframe(iframe));
      }
    } catch (error) {
      console.log(
        "Cannot access iframe content (cross-origin):",
        error.message,
      );
    }
  }
}

function applyThemeToIframe(iframe) {
  try {
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    const iframeHtml = iframeDoc.documentElement;

    if (iframeHtml) {
      iframeHtml.style.backgroundColor =
        theme.value === "dark" ? "#14161e" : "#FFFFFF";
      iframeHtml.style.color = theme.value === "dark" ? "#FFFFFF" : "#14161e";

      const iframeBody = iframeDoc.body;
      if (iframeBody) {
        iframeBody.style.backgroundColor =
          theme.value === "dark" ? "#14161e" : "#FFFFFF";
        iframeBody.style.color =
          theme.value === "dark" ? "#FFFFFF" : "#14161e";
      }

      iframeHtml.setAttribute("data-theme", theme.value);
    }
  } catch (error) {
    console.log("Cannot modify iframe content:", error.message);
  }
}

function updateButtonState() {
  const themeToggle = document.querySelector("#toggle-theme-switcher");
  if (themeToggle) {
    themeToggle.setAttribute("data-theme", theme.value);

    const hiddenText = themeToggle.querySelector(".toggle-button-text");
    if (hiddenText) {
      hiddenText.textContent =
        theme.value === "dark"
          ? "Switch to light mode"
          : "Switch to dark mode";
    }
  }
}

function onClick(themeValue) {
  theme.value = themeValue;

  setPreference();
  updateMetaThemeColor();
  updateCommentsWrapperColor();
  updateButtonState();
}

function getColorPreference() {
  if (localStorage.getItem(storageKey)) {
    return localStorage.getItem(storageKey);
  }

  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

function setPreference() {
  localStorage.setItem(storageKey, theme.value);
  reflectPreference();
  updateMetaThemeColor();
}

function reflectPreference() {
  document.firstElementChild.setAttribute("data-theme", theme.value);
}

function updateMetaThemeColor() {
  const metaThemeColor = document.querySelector('meta[name="theme-color"]');
  const newColor = theme.value === "dark" ? themeColors.dark : themeColors.light;
  if (metaThemeColor) {
    metaThemeColor.setAttribute("content", newColor);
  }
}

function initThemeToggle() {
  const themeToggle = document.querySelector("#toggle-theme-switcher");
  const switcher = document.querySelector("[data-theme-switcher]");

  if (!switcher || !themeToggle) {
    return;
  }

  reflectPreference();
  updateMetaThemeColor();
  updateCommentsWrapperColor();
  updateButtonState();

  themeToggle.addEventListener("click", () => {
    const newTheme = theme.value === "dark" ? "light" : "dark";
    onClick(newTheme);
  });

  window
    .matchMedia("(prefers-color-scheme: dark)")
    .addEventListener("change", ({ matches: isDark }) => {
      theme.value = isDark ? "dark" : "light";

      setPreference();
      updateMetaThemeColor();
      updateCommentsWrapperColor();
      updateButtonState();
    });
}

document.addEventListener("DOMContentLoaded", () => {
  initNavBurger();
  initMusicAlbumHover();
  initMoviePosterHover();
  initActiveNavLinks();
  initThemeToggle();
});
